import { render, staticRenderFns } from "./lateral.vue?vue&type=template&id=41c811e6&scoped=true&"
import script from "./lateral.vue?vue&type=script&lang=js&"
export * from "./lateral.vue?vue&type=script&lang=js&"
import style0 from "./lateral.vue?vue&type=style&index=0&id=41c811e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c811e6",
  null
  
)

export default component.exports